
/* controllers Name

for switch : "showSwitch",
for text  : "showInput",
for slider : "showSlider",
for Radio Buttons : "showRadio"

*/
export var ui_settings={
	"mobile_signal" : {
		ida_id : 71,
		title: "set_mobile_signal_alert_level",
		desc: "settings_mobile_signal_desc",
		control: "showSlider",
		storagepath : "eval.mobile.mobile_signal",
		res : "ok",
		defvalue : 40,
		min : 0,
		max : 100,
		units : "",
		btn1 : "cancel_btn",
		btn2 : "ok_btn",
		show : false // should fix the units first. earlier signal was shown in percentage. now its dbm
	},
	"wifi_internet_monitor" :{
		ida_id : 13,
		title: "set_wifi_internet_latency",
		desc: "settings_wifi_internet_monitor_desc",
		control: "showSlider",
		storagepath : "eval.wifi_internet.latency",
		res : "prob",
		defvalue : 40,
		min : 1,
		max : 500,
		units : "",
		btn1 : "cancel_btn",
		btn2 : "ok_btn",
		show : true
	},
	"mobile_internet_monitor" :{
		ida_id : 21,
		title: "set_mobile_internet_latency",
		desc: "settings_wifi_internet_monitor_desc",
		control: "showSlider",
		storagepath : "eval.mobile_internet.latency",
		res : "prob",
		defvalue : 40,
		min : 1,
		max : 1000,
		units : "",
		btn1 : "cancel_btn",
		btn2 : "ok_btn",
		show : true
	},
	"wifi_router_monitor" :{
		ida_id : 0,
		title: "set_wifi_router_latency",
		desc: "settings_wifi_internet_monitor_desc",
		control: "showSlider",
		storagepath : "eval.wifi_router.latency",
		res : "prob",
		defvalue : 300,
		min : 1,
		max : 500,
		units : "",
		btn1 : "cancel_btn",
		btn2 : "ok_btn",
		show : true
	},
	"fixed_line" :{
		ida_id : 0,
		title: "set_fixed_line_latency",
		desc: "settings_wifi_internet_monitor_desc",
		control: "showSlider",
		storagepath : "eval.fixed_line.latency",
		res : "prob",
		defvalue : 300,
		min : 1,
		max : 500,
		units : "",
		btn1 : "cancel_btn",
		btn2 : "ok_btn",
		show : true
	},
	"fixed_line_last_ip" :{
		ida_id : 0,
		title: "set_fixed_line_latency",
		desc: "settings_wifi_internet_monitor_desc",
		control: "showSlider",
		storagepath : "eval.fixed_line.latency",
		res : "prob",
		defvalue : 300,
		min : 1,
		max : 500,
		units : "",
		btn1 : "cancel_btn",
		btn2 : "ok_btn",
		show : true
	},
	"wifi_trace_route" : {
		"more_btn" : _TDC?0:1,
		"more_fun" : "VisualTraceRoute",
		"more_table" : "result_data",
		"more_priority" : 1, // to show more button even though evaluation is warn/prob
		"more_btn_in_history" : 1
	},
	"mobile_trace_route" : {
		"more_btn" : _TDC?0:1,
		"more_fun" : "VisualTraceRoute",
		"more_table" : "result_data",
		"more_priority" : 1,
		"more_btn_in_history" : 1
	},
	"LocalScan" : {
		"more_btn" : 1,
		"more_fun" : "DeviceList",
		"more_table" : "Network Devices",
		"more_priority" : 1,
		"more_btn_in_history" : 0
	},
	"wifi_optimizer" : {
		"more_btn" : +!_TDC,
		"more_fun" :"wifichannels",
		"more_table" : "result_data",
		"more_priority" : 1,
		"more_btn_in_history" : 1
	},
	"router_connection": {
		"reboot_btn": +!_TDC
	},
	"routering": {
		"get_logs_btn": +!_TDC,
		"get_logs_fun": "router_log"
	},
	"internet_consumption" : {
		"more_btn" : +!_TDC,
		"more_fun" :"AppsInternetUsage",
		"more_priority" : 1,
		"more_btn_in_history" : 0
	},
	"running_apps" : {
		"more_btn" : +!_TDC,
		"more_fun" :"#/app/AppsUsage",
		"more_priority" : 1,
		"more_btn_in_history" : 0
	}
};

export default ui_settings;
